module.exports = __webpack_public_path__ + "static/media/presse01.b556c52e.png";